<div
  bsModal
  #tosModal="bs-modal"
  (onShow)="onShow()"
  (onHidden)="onHide()"
  class="modal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myLargeModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog--text-left">
    <app-popovers-back (click)="tosModal.hide()"></app-popovers-back>
    <div class="modal__container invert" [ngClass]="{ 'loading loading--transparent': isLoading }">
      <div class="modal-body" *ngIf="legalTexts && legalTexts.termsOfUse" [innerHTML]="legalTexts.termsOfUse"></div>
      <div class="modal-footer">
        <!-- <button type="button" class="btn btn-primary" (click)="termsAndServiceModal.hide();">Agree</button> -->
      </div>
    </div>
  </div>
</div>
<div
  bsModal
  #cookieModal="bs-modal"
  (onShow)="onShow()"
  (onHidden)="onHide()"
  class="modal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myLargeModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog--text-left">
    <app-popovers-back (click)="cookieModal.hide()"></app-popovers-back>
    <div class="modal__container invert" [ngClass]="{ 'loading loading--transparent': isLoading }">
      <div class="modal-body" *ngIf="legalTexts && legalTexts.cookiePolicy" [innerHTML]="legalTexts.cookiePolicy"></div>
      <div class="modal-footer">
        <!-- <button type="button" class="btn btn-primary" (click)="termsAndServiceModal.hide();">Agree</button> -->
      </div>
    </div>
  </div>
</div>
<div
  bsModal
  #privacyModal="bs-modal"
  (onShow)="onShow()"
  (onHidden)="onHide()"
  class="modal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myLargeModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog--text-left">
    <app-popovers-back (click)="privacyModal.hide()"></app-popovers-back>
    <div class="modal__container invert" [ngClass]="{ 'loading loading--transparent': isLoading }">
      <div class="modal-body" *ngIf="legalTexts && legalTexts.privacyPolicy" [innerHTML]="legalTexts.privacyPolicy"></div>
      <div class="modal-footer">
        <!-- <button type="button" class="btn btn-primary" (click)="termsAndServiceModal.hide();">Agree</button> -->
      </div>
    </div>
  </div>
</div>
<div
  bsModal
  #weightChangeModal="bs-modal"
  (onShow)="onShow()"
  (onHidden)="onHide()"
  [config]="{ backdrop: 'static' }"
  class="modal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myLargeModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <app-popovers-back (click)="weightChangeModal.hide()"></app-popovers-back>
    <div class="modal__container invert">
      <div class="modal-body">
        <p class="modal__text" i18n="@@largeWeightChangeUpdateMenuExplanation">
          For larger weight changes we can update the menu amounts from tomorrow
        </p>
        <p i18n="@@largeWeightChangeUpdateMenu">
          Would you like to update the menu amounts, besides updating your weight?
        </p>
      </div>
      <div class="modal-footer">
        <button type="submit" class="btn btn-custom-secondary" (click)="runCallback2()" i18n="@@onlyUpdateWeight">
          No, only update weight
        </button>
        <button type="submit" class="btn btn-custom-secondary" (click)="runCallback1()" i18n="@@updateWeightAndMenu">
          Update menu
        </button>
      </div>
    </div>
  </div>
</div>
<div
  bsModal
  #confirmUpdateProfileModalContent="bs-modal"
  (onShow)="onShow()"
  (onHidden)="onHide()"
  [config]="{ backdrop: 'static' }"
  class="modal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myLargeModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <app-popovers-back (click)="confirmUpdateProfileModalContent.hide()"></app-popovers-back>
    <div class="modal__container invert">
      <div class="modal-body">
        <span class="h1" i18n="@@changeRecipeAndShoppingList">
          This will change your recipes and shopping list!
        </span>
        <p i18n="@@areYouSure">Are you sure?</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-custom-secondary" (click)="confirmUpdateProfileModalContent.hide()" i18n="@@noCancel">
          No, cancel
        </button>
        <button type="button" class="btn btn-custom-secondary" (click)="runCallback1()" i18n="@@cancel">
          Update
        </button>
      </div>
    </div>
  </div>
</div>
<div
  bsModal
  #confirmGiftModalContent="bs-modal"
  (onShow)="onShow()"
  (onHidden)="onHide()"
  [config]="{ backdrop: 'static' }"
  class="modal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myLargeModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <app-popovers-back (click)="confirmGiftModalContent.hide()"></app-popovers-back>
    <div class="modal__container invert">
      <div class="modal-body">
        <span class="h1" i18n="@@confirmGiftModalContentTitle">
          Congratulations! Somebody gifted you access to my personalised meal plan.
        </span>
        <p i18n="@@confirmGiftModalContentBody">Let’s get cooking!.</p>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-custom-secondary"
          (click)="confirmGiftModalContentCancel()"
          i18n="@@confirmGiftModalContentCancel"
        >
          Back
        </button>
        <button type="button" class="btn btn-primary" (click)="runCallback1()" i18n="@@confirmGiftModalContentAccept">
          Accept gift
        </button>
      </div>
    </div>
  </div>
</div>
<div
  bsModal
  #targetWeightChangeModal="bs-modal"
  (onShow)="onShow()"
  (onHidden)="onHide()"
  [config]="{ backdrop: 'static' }"
  class="modal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myLargeModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <app-popovers-back (click)="targetWeightChangeModal.hide()"></app-popovers-back>
    <div class="modal__container invert">
      <div class="modal-body">
        <span class="h1" i18n="@@recalculateMenus">
          Recalculate menus?
        </span>
        <p i18n="@@recalculateMenusExplanation">
          Changing your weight by that much means that your recommended caloric intake changes, too.We can update your menu right now, but
          by doing that your shopping list will also be reset.
        </p>
        <p i18n="@@recalculateMenusQuestion">
          Would you like to update your menu immediately, or let it catch up over time?
        </p>
      </div>
      <div class="modal-footer">
        <button type="submit" class="btn btn-custom-secondary" (click)="targetWeightChangeModal.hide()" i18n="@@recalculateMenusAnswerOne">
          Leave my menu as-is
        </button>
        <button
          type="submit"
          class="btn btn-custom-secondary"
          (click)="runCallback1(); targetWeightChangeModal.hide()"
          i18n="@@recalculateMenusAnswerTwo"
        >
          Recalculate now!
        </button>
      </div>
    </div>
  </div>
</div>
<div
  bsModal
  #confirmAddMemberModalContent="bs-modal"
  (onShow)="onShow()"
  (onHidden)="onHide()"
  [config]="{ backdrop: 'static' }"
  class="modal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myLargeModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <app-popovers-back (click)="confirmAddMemberModalContent.hide()"></app-popovers-back>
    <div class="modal__container invert">
      <div class="modal-body">
        <span class="h1" i18n="@@thisChangesRecipesAndShoppingList">
          This will change your recipes and shopping list!
        </span>
        <p i18n="@@areYouSure">Are you sure?</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-custom-secondary" (click)="confirmAddMemberModalContent.hide()" i18n="@@modalCancelAddMember">
          No, cancel
        </button>
        <button type="button" class="btn btn-custom-secondary" (click)="runCallback1()" i18n="@@modalAddMember">
          Add
        </button>
      </div>
    </div>
  </div>
</div>
<div
  bsModal
  #cancelSubscriptionModalContent="bs-modal"
  (onShow)="onShow()"
  (onHidden)="onHide()"
  [config]="{ backdrop: 'static' }"
  class="modal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myLargeModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <app-popovers-back (click)="cancelSubscriptionModalContent.hide()"></app-popovers-back>
    <div class="modal__container invert">
      <div class="modal-body">
        <span class="h1" i18n="@@doYouWantToLeave">
          Do you really want to leave?
        </span>

        <p i18n="@@leavingConfirmationErik">
          Are you really sure that you want to stop your membership? You will not be able to use Fitcat, unless you re-subscribe!
        </p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="cancelSubscriptionModalContent.hide()" i18n="@@leavingConfirmationAnswerOne">
          Keep my account
        </button>
        <button
          type="button"
          class="btn btn-custom-danger"
          (click)="runCallback1(); cancelSubscriptionModalContent.hide()"
          i18n="@@leavingConfirmationAnswerTwo"
        >
          Stop my membership
        </button>
      </div>
    </div>
  </div>
</div>
<div
  bsModal
  #emailLoginModal="bs-modal"
  (onShow)="onShow()"
  (onHidden)="onHide()"
  class="modal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myLargeModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog--limit-size">
    <app-popovers-back (click)="emailLoginModal.hide()"></app-popovers-back>
    <div class="modal__container invert">
      <form
        [formGroup]="magicLinkForm"
        (ngSubmit)="savedEmail = magicLinkForm.controls['email'].value; runCallback1(magicLinkForm, savedEmail)"
      >
        <div class="modal-body">
          <span class="h1 mt-1 modal__header" i18n="@@magicLinkExplanation">
            Log in using an e-mail
          </span>
          <div class="form-group">
            <input
              type="email"
              class="form-control modal__input"
              [ngClass]="{ invalid: magicLinkForm.invalid && !magicLinkForm.pristine, valid: magicLinkForm.valid }"
              formControlName="email"
              name="email"
              i18n-placeholder="@@emailExample"
              placeholder="name@example.com"
            />
          </div>
          <button type="submit" class="btn btn-primary" i18n="@@sendMagicLinkButton">
            Send me the login link!
          </button>
        </div>
      </form>
      <form
        [formGroup]="form"
        *ngIf="env.passwordLoginEnabled && options && options.showPassLogin"
        (ngSubmit)="savedEmail = form.controls['email'].value; runCallback2(form, savedEmail)"
      >
        <div class="modal-body">
          <span class="h1 mt-1 modal__header" i18n="@@enterYourEmail">
            Log in using an e-mail & password
          </span>
          <div class="form-group">
            <input
              type="email"
              class="form-control modal__input"
              [ngClass]="{ invalid: form.get('email').invalid && !form.get('email').pristine, valid: form.get('email').valid }"
              formControlName="email"
              name="email"
              i18n-placeholder="@@emailExample"
              placeholder="name@example.com"
            />
          </div>
          <div class="form-group">
            <input
              type="password"
              class="form-control modal__input"
              [ngClass]="{ invalid: form.get('password').invalid && !form.get('password').pristine, valid: form.get('password').valid }"
              formControlName="password"
              name="password"
              i18n-placeholder="@@passwordExample"
              placeholder="Password"
            />
          </div>
          <button type="submit" class="btn btn-primary" i18n="@@logIn">
            Login
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
<div
  bsModal
  #emailLoginErrorModal="bs-modal"
  (onShow)="onShow()"
  (onHidden)="onHide()"
  class="modal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myLargeModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog--limit-size">
    <app-popovers-back (click)="emailLoginErrorModal.hide()"></app-popovers-back>
    <div class="modal__container invert">
      <div class="modal-body">
        <span class="h1 mt-1 modal__header" i18n="@@loginFailedHeader">
          Login failed
        </span>
        <p class="modal__text" i18n="@@loginFailedText">
          If you have forgotten your password, we can send a button to
          <strong>{{ savedEmail }}</strong>
          , that you can use to log in safely.
        </p>
        <p>
          <button
            type="button"
            class="btn btn-custom-secondary"
            (click)="runCallback1(magicLinkForm, savedEmail); emailLoginErrorModal.hide()"
            i18n="@@magicLinkExplanation"
          >
            Log in using an e-mail
          </button>
        </p>
        <p class="modal__text mt-2" i18n="@@loginFailedTextAgain">
          If you want to correct the email or enter the password:
        </p>
        <p>
          <button
            type="button"
            class="btn btn-custom-secondary"
            (click)="emailLoginErrorModal.hide(); emailLoginModal.show()"
            i18n="@@enterNewEmail"
          >
            Go back and try again
          </button>
        </p>
      </div>
    </div>
  </div>
</div>
<div
  bsModal
  #emailLoginConfirmationModal="bs-modal"
  (onShow)="onShow()"
  (onHidden)="onHide()"
  class="modal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myLargeModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog--limit-size">
    <app-popovers-back (click)="emailLoginConfirmationModal.hide()"></app-popovers-back>
    <div class="modal__container invert">
      <div class="modal-body">
        <span class="h1 mt-1 modal__header" i18n="@@checkInbox">
          Check your inbox!
        </span>
        <p class="modal__text" i18n="@@magicLinkSent">
          We sent a special email to
          <strong>{{ savedEmail }}</strong>
          . Check your email - if you can't find it, then also check the junk mail.
        </p>
        <p class="modal__text mt-2" i18n="@@loginFailedTextAgain" *ngIf="env.passwordLoginEnabled">
          If you want to correct the email or enter the password:
        </p>
        <p class="modal__text mt-2" i18n="@@loginFailedTextAgainNoPass" *ngIf="!env.passwordLoginEnabled">
          If you want to correct the email:
        </p>
        <p>
          <button
            type="button"
            class="btn btn-custom-secondary"
            (click)="emailLoginConfirmationModal.hide(); emailLoginModal.show()"
            i18n="@@enterNewEmail"
          >
            Go back and try again
          </button>
        </p>
      </div>
    </div>
  </div>
</div>
<div
  bsModal
  #subscriptionNeededModal="bs-modal"
  class="modal"
  [config]="{ backdrop: 'static' }"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myLargeModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <app-popovers-back (click)="subscriptionNeededModal.hide()"></app-popovers-back>
    <div class="modal__container invert">
      <div class="modal-body">
        <div *ngIf="this.options && !this.options.paidUntil">
          <h2 class="h1" i18n="@@recipeSubscriptionTrialEnded">
            Your free trial has ended
          </h2>

          <p i18n="@@recipeSubscriptionEndedContentOneErikorgu">
            Your free trial has ended and Fitcat will no longer generate personalised menus for you.
          </p>
        </div>
        <div *ngIf="this.options && this.options.paidUntil">
          <h2 class="h1" i18n="@@recipeSubscriptionEnded">
            Your subscription has ended
          </h2>

          <p i18n="@@recipeSubscriptionEndedContentTwoErikorgu">
            Your subscription has ended and Fitcat will no longer generate personalized menus for you.
          </p>
        </div>

        <p class="mb-0" i18n="@@recipeSubscriptionEndedContentThreeErikorgu">
          Become a member to keep going! Membership options start at €10.99 per month
        </p>
      </div>
      <div class="modal-footer">
        <a (click)="goToSubscription()" class="btn btn-custom-secondary" i18n="@@recipeSubscriptionEndedAction">
          See subscription options
        </a>
      </div>
    </div>
  </div>
</div>
<div
  bsModal
  class="modal modal--pdf-share"
  tabindex="-1"
  role="dialog"
  aria-hidden="true"
  #shareMeal="bs-modal"
  (onShow)="onShow()"
  (onHidden)="onHide()"
>
  <div class="modal-dialog">
    <app-popovers-back (click)="shareMeal.hide()"></app-popovers-back>
    <div class="modal__container invert" [ngClass]="{ 'loading loading--inverted': shareProcessing }">
      <form novalidate [formGroup]="shareMealForm" (submit)="handleShareMealEmail()">
        <div class="modal-body">
          <h3 class="mt-2 modal__header" i18n="@@shareMealDaysFormPrintSingle">
            Print or save recipe:
          </h3>
          <!-- download pdf -->
          <p>
            <button class="btn btn-custom-secondary btn-download-pdf" type="button" (click)="handleShareMealPdf()">
              <span i18n="@@shareMealDaysFormDownload">Download the PDF file</span>
            </button>
          </p>
          <!-- send email -->
          <h3 class="mt-1 modal__header" i18n="@@recipesSingleShareTitle">
            Share this recipe by email:
          </h3>
          <div class="form-group">
            <input
              class="form-control modal__input"
              formControlName="email"
              type="email"
              name="email"
              [ngClass]="{ invalid: shareMealForm.invalid && !shareMealForm.pristine, valid: shareMealForm.valid }"
              i18n-placeholder="@@recipesMainEmailPlaceholder"
              placeholder="To: (e.g mr-chef@example.com)"
            />
          </div>
          <p class="mb-0" i18n="@@recipesSingleShareDesc">
            We'll send the recipient the recipe complete with photo, ingredients and cooking instructions.
          </p>
        </div>
        <div class="modal-footer">
          <button class="btn btn-custom-secondary" type="button" (click)="shareMeal.hide()" i18n="@@recipesMainCTACancel">
            No, cancel
          </button>
          <button class="btn btn-primary btn-block" type="submit" [disabled]="shareMealForm.invalid" i18n="@@recipesMainCTAShare">
            Send
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
<div
  bsModal
  class="modal modal--pdf-share"
  tabindex="-1"
  role="dialog"
  aria-hidden="true"
  #shareMenu="bs-modal"
  (onShow)="onShow()"
  (onHidden)="onHide()"
>
  <div class="modal-dialog">
    <app-popovers-back (click)="shareMenu.hide()"></app-popovers-back>
    <div class="modal__container invert" [ngClass]="{ 'loading loading--inverted': shareProcessing }">
      <form novalidate [formGroup]="shareMenuForm" (submit)="handleShareMenuEmail()">
        <div class="modal-body">
          <!-- download pdf -->
          <app-day-selector *ngIf="options && options.dates && options.dates.length > 1" [dates]="options.dates"></app-day-selector>
          <h3 class="mt-2 modal__header" i18n="@@shareMealDaysFormPrint">
            Print or save recipes:
          </h3>
          <p>
            <button class="btn btn-custom-secondary btn-download-pdf" type="button" (click)="handleShareMenuPdf()">
              <span i18n="@@shareMealDaysFormDownload">Download the PDF file</span>
            </button>
          </p>
          <!-- send email -->
          <h3 class="mt-2 modal__header" i18n="@@shareMealDaysFormEmail">
            Share menus by email:
          </h3>
          <div class="form-group">
            <input
              class="form-control modal__input"
              formControlName="email"
              type="email"
              name="email"
              [ngClass]="{ invalid: shareMenuForm.invalid && !shareMenuForm.pristine, valid: shareMenuForm.valid }"
              i18n-placeholder="@@recipesMainEmailPlaceholder"
              placeholder="To: (e.g mr-chef@example.com)"
            />
          </div>
          <p i18n="@@recipesDaysSharePDFDesc">
            We'll send the PDF file with all the recipes.
          </p>
        </div>
        <div class="modal-footer">
          <button class="btn btn-custom-secondary" type="button" (click)="shareMenu.hide()" i18n="@@recipesMainCTACancel">
            No, cancel
          </button>
          <button class="btn btn-primary btn-block" type="submit" [disabled]="shareMenuForm.invalid" i18n="@@recipesMainCTAShare">
            Send
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
<div
  bsModal
  #banklinkPolling="bs-modal"
  (onShow)="onShow()"
  (onHidden)="onHide()"
  class="modal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myLargeModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <app-popovers-back (click)="banklinkPolling.hide()"></app-popovers-back>
    <div class="modal__container invert">
      <div class="modal-body text-xs-center">
        <h3 class="h2" i18n="@@popoverBanklinkPollingHeading">
          Payment in progress
        </h3>
        <div style="position: relative; height: 60px;" class="loading loading--transparent"></div>
        <p i18n="@@popoverBanklinkPolling">Please wait</p>
        <p class="mb-0">
          <a href="javascript:void(0);" (click)="banklinkPolling.hide()" i18n="@@popoverBanklinkPollingClose">
            Close
          </a>
        </p>
      </div>
    </div>
  </div>
</div>
<div bsModal #newList="bs-modal" (onShow)="onShow()" (onHidden)="onHide()" class="modal" tabindex="-1" role="dialog">
  <div class="modal-dialog">
    <app-popovers-back (click)="newList.hide()"></app-popovers-back>
    <div class="modal__container invert">
      <div class="modal-body">
        <span class="h1" i18n="@@removeShoppingList">
          This will remove your current list!
        </span>
        <p i18n="@@createNewShoppingList">
          By creating a new shopping list your current list(along with anything you have or haven't checked) will be lost. Are you sure?
        </p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-custom-secondary" (click)="newList.hide()" i18n="@@noCancel">
          No, cancel
        </button>
        <button type="button" class="btn btn-custom-secondary" (click)="runCallback1()" i18n="@@discardList">
          Discard the list
        </button>
      </div>
    </div>
  </div>
</div>

<div bsModal #addItem="bs-modal" (onShow)="onShow()" (onHidden)="onHide()" class="modal" tabindex="-1" role="dialog">
  <div class="modal-dialog">
    <app-popovers-back (click)="addItem.hide()"></app-popovers-back>
    <div class="modal__container invert" [ngClass]="{ 'loading loading--inverted': isLoading }">
      <form [formGroup]="addItemForm" novalidate (submit)="addItemFormSubmit()">
        <div class="modal-body">
          <h3 class="h1 mt-1 modal__header" i18n="@@addOtherItemModalHeader">
            What would you like to add?
          </h3>
          <div class="form-group">
            <input
              class="form-control modal__input"
              formControlName="name"
              [ngClass]="{ invalid: addItemForm.invalid && !addItemForm.pristine }"
              name="name"
              type="text"
              i18n-placeholder="@@addOtherItemModalPlaceholder"
              placeholder='E.g. "toothpaste" or "flowers"'
            />
          </div>
          <p class="btn-group--fluid">
            <button type="button" class="btn btn-custom-secondary" (click)="addItem.hide(); isLoading = false" i18n="@@addOtherItemCancel">
              Cancel
            </button>
            <button type="submit" class="btn btn-primary btn-block" [disabled]="addItemForm.invalid" i18n="@@addOtherItemSave">
              Add to list
            </button>
          </p>
        </div>
      </form>
    </div>
  </div>
</div>

<div bsModal #removeItem="bs-modal" (onShow)="onShow()" (onHidden)="onHide()" class="modal" tabindex="-1" role="dialog">
  <div class="modal-dialog">
    <app-popovers-back (click)="removeItem.hide()"></app-popovers-back>
    <div class="modal__container invert" [ngClass]="{ 'loading loading--inverted': isLoading }">
      <div class="modal-body">
        <h3 class="h1 mt-1 modal__header" i18n="@@removeOtherItemModalHeader">Remove "{{ options?.name | aisleIngredient }}"?</h3>
        <p class="btn-group--fluid">
          <button
            type="button"
            class="btn btn-custom-secondary"
            (click)="removeItem.hide(); isLoading = false"
            i18n="@@removeOtherItemCancel"
          >
            No, keep it
          </button>
          <button
            type="button"
            class="btn btn-custom-danger btn-block"
            (click)="isLoading = true; runCallback1()"
            i18n="@@removeOtherItemRemove"
          >
            Yes, remove
          </button>
        </p>
      </div>
    </div>
  </div>
</div>

<div bsModal #shareList="bs-modal" (onShow)="onShow()" (onHidden)="onHide()" class="modal" tabindex="-1" role="dialog">
  <div class="modal-dialog">
    <app-popovers-back (click)="shareList.hide()"></app-popovers-back>
    <div class="modal__container invert" [ngClass]="{ 'loading loading--inverted': isLoading }">
      <form [formGroup]="shareForm" novalidate (submit)="shareFormSubmit()">
        <div class="modal-body">
          <h3 class="h1 mt-1 modal__header" i18n="@@ShoppingMainShareTitle">
            Share this list by e-mail:
          </h3>
          <div class="form-group">
            <input
              class="form-control modal__input"
              formControlName="email"
              [ngClass]="{ invalid: shareForm.invalid && !shareForm.pristine, valid: shareForm.valid }"
              name="email"
              type="email"
              i18n-placeholder="@@shoppingMainEmailPlaceholder"
              placeholder="To: (e.g mr-chef@example.com)"
            />
          </div>
          <p class="mb-0" i18n="@@ShoppingMainShareDesc">
            They will receive the full list of ingredients, amounts needed and tips on how to pick the best items.
          </p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-custom-secondary" (click)="shareList.hide()" i18n="@@ShoppingMainCTACancel">
            No, cancel
          </button>
          <button type="submit" class="btn btn-primary btn-block" [disabled]="shareForm.invalid" i18n="@@ShoppingMainCTAShare">
            Send
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<div class="modal" bsModal #createCart="bs-modal" (onShow)="onShow()" (onHidden)="onHide()" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog">
    <app-popovers-back (click)="createCart.hide()"></app-popovers-back>
    <div class="modal__container invert">
      <div class="modal-body">
        <div class="modal-shopcart">
          <div class="modal-shopcart__header">
            <h3 class="h2 mt-2 modal__header">
              <ng-container i18n="@@shoplistViewPopoverMsgHeading">
                Get fresh produce delivered to your house!
              </ng-container>
            </h3>
            <img src="assets/foodmood_logo.png" />
          </div>
          <p>
            <ng-container i18n="@@shoplistViewPopoverMsgContent">
              FreshGO will deliver foodstuffs and other goods to your door in and around Tallinn.
            </ng-container>
          </p>
          <p>
            <ng-container i18n="@@shoplistViewPopoverMsgContent2">
              Before submitting your order, please remove any items that you already have, or that you don’t wish to order. We will direct
              you to FreshGO’s website to securely complete your order.
            </ng-container>
          </p>
          <p>
            <app-checkbox [selected]="shopCartDisabled" (change)="toggleShopCardDisabled()">
              <ng-container i18n="@@shoplistViewPopoverMsgDisable">Do not show this again</ng-container>
            </app-checkbox>
          </p>
        </div>
      </div>
      <div class="modal-footer modal-footer--nowrap">
        <app-button type="link" [iconLeft]="'#icon_arrow_left'" size="lg" (click)="createCart.hide()">
          <ng-container i18n="@@shoplistViewPopoverMsgCancel">Back</ng-container>
        </app-button>
        <app-button class="is-wide" type="primary" [iconRight]="'#icon_next'" size="lg" (click)="createCartContinue()">
          <ng-container i18n="@@shoplistViewPopoverMsgSubmit">Continue with order</ng-container>
        </app-button>
      </div>
    </div>
  </div>
</div>

<div class="modal" bsModal #resendCart="bs-modal" (onShow)="onShow()" (onHidden)="onHide()" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog">
    <app-popovers-back (click)="resendCart.hide()"></app-popovers-back>
    <div class="modal__container invert">
      <div class="modal-body">
        <div class="modal-shopcart">
          <h3 class="h2 mt-2 modal__header" i18n="@@shoplistResetPopoverHeading">
            You have already submitted this shopping list
          </h3>
          <p i18n="@@shoplistResetPopoverMsg1">
            If you did not complete your order, then open FreshGO’s to pick up where you left off.
          </p>
          <p i18n="@@shoplistResetPopoverMsg2">
            If you wish to change your order, then you can start anew and send a new shopping list to FreshGO.
          </p>
        </div>
      </div>
      <div class="modal-footer modal-footer--nowrap">
        <app-button type="secondary" size="lg" (click)="resendCartContinue()" i18n="@@shoplistResetPopoverOpen">
          Open FreshGO
        </app-button>
        <app-button type="primary" size="lg" (click)="resendCartReset()" i18n="@@shoplistResetPopoverHeadingReset">
          Start again
        </app-button>
      </div>
    </div>
  </div>
</div>

<div #shareEmailModalSuccess hidden i18n="@@ShoppingMainAlertShareSuccess">
  E-mail sent successfully!
</div>
<div #generalErrorMessage hidden i18n="@@ShoppingMainAlertShareError">
  Something went wrong! Please try again
</div>
